import {TreeConfig} from '@spout/any-shared/models';
import {uuid} from '../uuid';

export function createInitialConfig(id?: string | null, name?: string): Partial<TreeConfig> {
  return {
    id: id ? id : uuid(),
    isDefault: false,
    parentId: '',
    name: name ? name : '',
    parentName: '',
    description: ''
  };
}
